import './widgets/pdp-zoom';
import './layout/product';

const isPageKitBiquini = document.body.classList.contains('kit-biquini');

/**
 * Zoom e slider
 */

const ZoomSlider = () => {
  const thumbs = document.querySelector('.thumbs') as Element;

  const listItems = thumbs?.querySelectorAll('li') as NodeListOf<HTMLLIElement>;

  const size = listItems?.length || 0;

  const includeElement = document.querySelector('#include');
  if (includeElement) {
    includeElement.remove();
  }

  const glideTrack = document.createElement('div');
  glideTrack.setAttribute('data-glide-el', 'track');
  glideTrack.classList.add('glide__track');
  thumbs?.parentNode?.insertBefore(glideTrack, thumbs);
  glideTrack.appendChild(thumbs);

  const showElement = document.querySelector('#show')!;
  showElement?.classList?.add('glide');

  const controlsHtml = `
  <div class="glide__arrows" data-glide-el="controls">
    <button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>
    <button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button>
  </div>
  <div class="glide__bullets" data-glide-el="controls[nav]">
    ${Array.from(listItems)
      .map((_, i) => `<button class="glide__bullet" data-glide-dir="=${i}">${i}</button>`)
      .join('')}
  </div>
`;

  showElement.insertAdjacentHTML('beforeend', controlsHtml);

  thumbs.classList.add('glide__slides');

  listItems.forEach((item) => {
    const anchor = item.querySelector('a');
    const zoomLoader = document.createElement('div');
    zoomLoader.classList.add('zoom-loader');
    zoomLoader.innerHTML = window.aguadecoco.helpers.loader.getHtmlLoader('spin');
    anchor?.appendChild(zoomLoader);
    item?.classList?.add('glide__slide');
  });

  const w = window.innerWidth;
  if (w > 1024) {
    const reversedItems = Array.from(listItems).reverse();
    reversedItems.forEach((li) => {
      thumbs.appendChild(li);
    });
  }

  window.aguadecoco.helpers.slider(
    '#show',
    {
      type: 'carousel',
      gap: 0,
      // autoplay: 3000,
      perView: Math.min(size),
      startAt: 0,
      breakpoints: {
        '1024': {
          perView: 2,
        },
        '768': {
          type: 'slider',
          perView: 1,
          startAt: 0,
        },
      },
    } as any,
    true,
  );

  const arrows = document.querySelector('.product-image .glide__arrows');

  document.querySelector('.product-first-row-left-col')?.append(arrows!);
  // arrows?.remove()

  const viewport = window.visualViewport;
  function resizeHandler() {
    if (viewport && viewport.scale > 1) {
      // change imagens to best zoom
      $('.thumbs a:not(.zoom-ready)').each(function (_i, a) {
        const $a = $(a);
        const $img = $a.find('img');
        $a.addClass('zoom-ready');
        const urlZoom = $a.attr('zoom') ?? '';
        urlZoom && $img.attr('src', urlZoom);
      });
    }
  }

  window.visualViewport?.removeEventListener('resize', resizeHandler);
  window.visualViewport?.addEventListener('resize', resizeHandler);
};

function hasProductWithYoutubeIframe() {
  const hasYoutubeIframe = (productDescription: string) => {
    const youtubeIframeRegex =
      /<iframe.*?src="((?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w\d_-]{11}).*?".*?>/gi;
    return youtubeIframeRegex.test(productDescription);
  };

  const description = document.querySelector('.productDescription .productDescription');

  if (hasYoutubeIframe(description?.innerHTML || '')) {
    console.log('🧩  Produto com iframe do YouTube encontrado!');
    description?.classList.add('yt-iframe-description');
    return true;
  }

  return false;
}

hasProductWithYoutubeIframe();

ZoomSlider();

/**
 * Tabelas de medida
 */
$(document).on('click', '.measurement-my-ideal-size', function () {
  if ((window as any).shapeStart) {
    (window as any).shapeStart();
  }
});

$(document).on('click', '.measurement-chart', function () {
  if ((window as any).shapeStart) {
    (window as any).shapeStart('table');
  }
});

/**
 * get selected sku
 */
const getSelectedSkuFromButtonBuy = (productIndex = 0) => {
  const paramsToObject = (entries: any) => {
    const result = {};
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  };
  const getParams = (url: string) => {
    const urlParams = new URLSearchParams(url);
    return paramsToObject(urlParams.entries()) as Record<string, any>;
  };

  if (!productIndex) {
    const $btnBuy = $('.product-add-to-cart .buy-in-page-button');
    return getParams(($btnBuy.attr('href') ?? '').split('?')[1]);
  } else {
    const $btnBuy = $(`.box-kit-${productIndex} .buy-in-page-button`);
    return getParams(($btnBuy.attr('href') ?? '').split('?')[1]);
  }

  return {};
};

/**
 * btn Buy
 */
(function buyHandler() {
  const alertOptions = function () {
    $('.product-selection').fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
  };

  let $btnBuy;

  if (isPageKitBiquini) {
    $btnBuy = [$('.box-kit-1 .buy-in-page-button'), $('.box-kit-2 .buy-in-page-button')];
  } else {
    $btnBuy = [$('.product-add-to-cart .buy-in-page-button')];
  }

  const $customBtnBuy = $('.add-to-cart-custom button');
  const $btnHtml = $customBtnBuy.html();

  $customBtnBuy.on('click', async function () {
    if (!$btnBuy.some(($btn) => ($btn.attr('href') ?? '').indexOf('alert') === -1)) {
      return alertOptions();
    }

    let params;

    if (isPageKitBiquini) {
      params = [getSelectedSkuFromButtonBuy(1), getSelectedSkuFromButtonBuy(2)];
    } else {
      params = [getSelectedSkuFromButtonBuy()];
    }

    params = params.filter((param) => param.sku);
    if (params.length === 0) {
      return alertOptions();
    }

    $customBtnBuy.addClass('loading');
    $customBtnBuy.prop('disabled', true);
    $customBtnBuy.text('Aguarde');

    $customBtnBuy.append(window.aguadecoco.helpers.loader.getHtmlLoader('spin'));

    await window.vtexjs.checkout.addToCart(
      params.map((param) => ({
        id: param.sku,
        quantity: param.qty ?? 1,
        seller: param.seller ?? 1,
      })),
    );

    $customBtnBuy.text('Adicionado!');

    setTimeout(() => {
      $customBtnBuy.html($btnHtml);
      $customBtnBuy.removeClass('loading');
      $customBtnBuy.prop('disabled', false);
    }, 4000);
  });
})();

/**
 * disable change image
 */

$(document).ready(function () {
  try {
    // window.imageControl_OnSkuImageRelatedSpecSelected = function () {
    //   console.log('🚀 ~ imageControl_OnSkuImageRelatedSpecSelected');
    // };
    // for (const key in skuEventDispatcher.events.skuDataReceived.listeners) {
    //   if (Object.prototype.hasOwnProperty.call(skuEventDispatcher.events.skuDataReceived.listeners, key)) {
    //     const listener = skuEventDispatcher.events.skuDataReceived.listeners[key];
    //     console.log('🚀 ~ listener.name:', listener.name);
    //     if (listener.name === 'imageControlListener' || listener.name === 'imageControlSpecSelectedListener') {
    //       skuEventDispatcher.events.skuDataReceived.listeners[key].callback = function () {
    //         console.log('bo');
    //       };
    //     }
    //   }
    // }
  } catch (error) {
    console.error(error);
  }
});

/**
 * Shipping Simulator
 */

function shippingSimulator() {
  const $box = $('.product-shipping');
  const $form = $box.find('form');
  const $input = $form.find('input');
  const $result = $box.find('.zipcode-container');
  const template = $box.find('script[type="text/template"]').text();
  const lastSearchedPostalCode = window.localStorage.getItem('lastSearchedPostalCode');
  template && window.aguadecoco.helpers.mustache.parse(template);

  if ($input.length) {
    if (lastSearchedPostalCode) {
      $input.val(lastSearchedPostalCode);
    }
    const cepInput = $input[0];
    new window.aguadecoco.helpers.Mask(cepInput);
    // cepInput.dispatchEvent(new Event('input', { bubbles: true }));
  } else {
    return false;
  }

  const setPostalCodeInCart = async (postalCode: string) => {
    showLoading();
    const value = postalCode.toString().replace(/\D/g, '');
    if (window.vtexjs.checkout.orderForm?.shippingData?.address?.postalCode !== value) {
      await window.vtexjs.checkout.calculateShipping({
        country: 'BRA',
        postalCode: value,
      });
    }
    hideLoading();
  };

  const applyTriggersInOptions = () => {
    $result.find('input[type="radio"]').on('change', function () {
      const $this = $(this);
      // const id = $this.val();
      const postalcode = $this.attr('data-postalcode');
      const $selected = $result.find(`input[type="radio"]:checked`);
      $selected.prop('checked', false);
      $this.prop('checked', true);
      if (postalcode) {
        setPostalCodeInCart(postalcode);
      }
    });
  };

  const showLoading = () => {
    $box.addClass('zipcode-loading');
  };

  const hideLoading = () => {
    $box.removeClass('zipcode-loading');
  };

  const calculateDeliveryTime = (shippingEstimate: string = '') => {
    if (shippingEstimate === '') {
      return 'Tempo de entrega não disponível';
    }

    const matchResult = shippingEstimate.match(/\d+/g);
    const value = matchResult ? parseInt(matchResult[0]) : NaN;
    if (isNaN(value)) {
      return 'Não consegui calcular o tempo de entrega';
    }
    const type = shippingEstimate.match(/\D+/g);
    const typeValue = type ? type[0] : '';

    switch (typeValue) {
      case 'bd': // business days
        if (value === 0) return 'Hoje';
        return value > 1 ? `${value} dias úteis` : 'um dia útil';
      case 'd': // days
        if (value === 0) return 'Hoje';
        return value > 1 ? `${value} dias` : 'um dia';
      case 'h': // hours
        return value > 1 ? `${value} horas` : 'uma hora';
      default:
        return 'Valor de tempo de entrega não reconhecido';
    }
  };

  const extractItemsFromLogisticsInfo = (data) => {
    if (!data?.logisticsInfo?.length) {
      return [];
    }

    return data.logisticsInfo[0].slas.map((sla) => {
      return {
        value: sla.id,
        id: sla.id,
        label: sla.name,
        postalcode: data.postalCode,
        price: window.aguadecoco.helpers.format.money(sla.price / 100),
        deliveryTime: calculateDeliveryTime(sla.shippingEstimate),
      };
    });
  };

  const renderOptions = (data: any) => {
    let html = '';
    if (data?.message) {
      html = window.aguadecoco.helpers.mustache.render(template, data);
    } else {
      if (data?.options?.length) {
        html = window.aguadecoco.helpers.mustache.render(template, {
          message: 'Não encontramos opções de entrega para este endereço',
        });
      } else {
        html = window.aguadecoco.helpers.mustache.render(template, {
          options: extractItemsFromLogisticsInfo(data),
        });
      }
    }
    html && $result.html(html);
    applyTriggersInOptions();
  };

  const searchPostalCode = async (postalCode: string) => {
    showLoading();
    let params;
    let sku;

    if (isPageKitBiquini) {
      params = [getSelectedSkuFromButtonBuy(1), getSelectedSkuFromButtonBuy(2)];
      sku = [
        params[0].sku ?? window.skuJson_1?.skus?.find((sku) => sku.available)?.sku,
        params[1].sku ?? window.skuJson_2?.skus?.find((sku) => sku.available)?.sku,
      ].filter((sku) => !!sku);
    } else {
      params = [getSelectedSkuFromButtonBuy()];
      sku = [params[0].sku ?? window.skuJson.skus.find((sku) => sku.available)?.sku].filter((sku) => sku);
    }

    if (!sku?.[0]) {
      renderOptions({ message: 'Produto não encontrado' });
      hideLoading();
      return;
    }
    const key = `${sku.join('')}-${postalCode}`;
    const localData = window.aguadecoco.helpers.storage.read(key);

    if (localData) {
      renderOptions(localData);
      hideLoading();
      return;
    }
    const data = await (await fetch(`/api/checkout/pub/postal-code/BRA/${postalCode}`)).json();

    if (data?.city) {
      const data = await window.vtexjs.checkout.simulateShipping(
        sku.map((sku, index) => ({ id: sku, quantity: params[index].qty ?? 1, seller: params[index].seller ?? 1 })),
        postalCode.toString().replace(/\D/g, ''),
        'BRA',
      );
      setPostalCodeInCart(postalCode); // async put postal code in cart
      window.aguadecoco.helpers.storage.save(key, data, 5);

      if (data?.messages?.length) {
        renderOptions({ message: data.messages.map(({ text }) => text).join('<br />') });
      } else {
        window.localStorage.setItem('lastSearchedPostalCode', postalCode);
        renderOptions(data);
      }
    } else {
      renderOptions({ message: 'CEP não encontrado' });
    }
    hideLoading();
  };

  $form.on('submit', function (e) {
    e.preventDefault();
    const cep = $input.val() as string;
    if (cep.length < 9) {
      $input.fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
      return;
    }
    searchPostalCode(cep);
  });

  if (lastSearchedPostalCode) {
    $(window).on('load', function () {
      searchPostalCode(lastSearchedPostalCode);
    });
  }
}

shippingSimulator();

/**
 * customizações para KIT Biquini
 */

const updateFocusImageOnKits = async () => {
  try {
    document.querySelector('.box-kit')?.classList.add('loading');
    // capturar 2 skus, um de cada produto do kit, buscar as imagens da posição 2 e usar no layout
    const skus = [`${window.skuJson_1?.skus?.[1]?.sku}`, `${window.skuJson_2?.skus?.[1]?.sku}`].filter((sku) => !!sku);
    const details = await window.aguadecoco.helpers.getSkuInfoByProductList(skus, 'skuId');

    $(`.box-kit .product-kit-image`).append(
      `<div class="loader" style="width:${$(`.box-kit .product-kit-image`).width()!}px;">${window.aguadecoco.helpers.loader.getHtmlLoader('spin')} </div>`,
    );

    skus.forEach((sku, index) => {
      const detail = details[sku];
      if (detail?.imagensUrl?.length >= 2) {
        const imageId = detail?.imagensUrl[1].imageUrl.match('/ids/(?<token>.*)/').groups.token;
        const imageParts = detail?.imagensUrl[1].imageUrl.split(`/${imageId}/`);
        const $productImageContainer = $(`.box-kit-${index + 1} .product-kit-image`);
        let $img = $(`.box-kit-${index + 1} .product-kit-image img`);

        const imageurl = `${imageParts[0]}/${imageId}-772-1156/${imageParts[1]}`;

        if ($img.length <= 0) {
          const img = $('<img />', {
            src: imageurl,
            alt: 'Image Description',
            width: '386',
            height: '578',
            loading: 'lazy',
          });

          img.on('load', () => {
            $(`.box-kit-${index + 1}`).addClass('img-loaded');
          });

          $productImageContainer.append(img);
          $img = $(`.box-kit-${index + 1} .product-kit-image img`);
          $img.addClass('image-focus-ready');
        } else {
          // $img.attr('src', imageurl).addClass('image-focus-ready');
        }

        $(`.box-kit-${index + 1} .product-kit-image`).wrap(
          `<a aria-label="link kit ${index + 1}" href="${detail.url}"> <span class="link-text-kit">${detail.productName} </span> </a>`,
        );
      }
    });
  } catch (error) {
    console.error(error);
  }
};

const discountFlag = (listPrice: number, bestPrice: number, container: JQuery<HTMLElement>) => {
  if (!listPrice || !bestPrice) return;
  const discount = ((listPrice - bestPrice) / listPrice) * 100;

  container.append(`<p class="flag discount">${discount.toFixed(0)}% OFF</p>`);
};

$(document).on('skuSelected.vtex', function () {
  const skuId = getSelectedSkuFromButtonBuy()?.sku;
  const sku = window.skuJson.skus.find((sku) => Number(sku.sku) === Number(skuId));
  if (!sku) return;

  discountFlag(sku.listPrice, sku.bestPrice, $('.product-first-row-left-col'));
});

if (!isPageKitBiquini) {
  discountFlag(
    Number(
      $('.skuListPrice')
        ?.html()
        ?.trim()
        ?.replace(/[^0-9,]/g, '')
        ?.replace(',', '.'),
    ),
    Number(
      $('.skuBestPrice')
        ?.html()
        ?.trim()
        ?.replace(/[^0-9,]/g, '')
        ?.replace(',', '.'),
    ),
    $('.product-first-row-left-col'),
  );
}

$(document).on('skuSelected.vtex', function (e) {
  $(e.target).parent().parent().find('.product-reference-container').addClass('show-sku');
});

const applyImagesOnSkuChange = async (sku: number) => {
  console.log('🧩  Trocando a imagem do Produto', sku);
  const container = document.querySelector('.product-first-row-left-col');
  const loader = container?.querySelector('.sku-changing-image-loader');

  container?.querySelector('.glide__arrows')?.remove();
  document.querySelector('.apresentacao .thumbs')?.remove();
  container?.classList.add('sku-changing-image');

  if (!loader) {
    $('.product-first-row-left-col .apresentacao').append(
      `<div class="sku-changing-image-loader"> ${window.aguadecoco.helpers.loader.getHtmlLoader('spin')} </div>`,
    );
  }
  const getSkuData = async (sku: number) => {
    const key = `pdp-image-${sku}`;
    const data = window.aguadecoco.helpers.storage.read(key);

    if (data) return data;

    const response = await window.getSkuData(sku);
    window.aguadecoco.helpers.storage.save(key, response);

    return response;
  };

  const updateURL = (url: string) => url.replace(/(\d+-\d+)(?=\/M)/, '728-1090');
  const response = await getSkuData(sku);
  const imagePaths = response.images.map((imageGroup) => imageGroup[0].Path);
  const updatedImagePaths = imagePaths.map(updateURL);

  const ul = document.createElement('ul');
  ul.classList.add('thumbs');

  updatedImagePaths.map((img, index) => {
    const li = document.createElement('li');
    ul.appendChild(li);

    const anchor = document.createElement('a');
    anchor.setAttribute('href', 'javascript:void(0);');
    anchor.setAttribute('rel', img);
    li.appendChild(anchor);

    const image = document.createElement('img');
    if (index + 1 === updatedImagePaths.length) {
      image.onload = () => {
        container?.classList.remove('sku-changing-image');
      };
    }
    image.src = img;
    image.width = 728;
    image.height = 1090;
    image.alt = img;
    anchor.appendChild(image);
  });

  document.querySelector('#show')!.innerHTML = ul.outerHTML;

  document
    .querySelector('.product-image')
    ?.setAttribute('style', `--product-image-width-lgm: calc(${386}px * ${ul.querySelectorAll('li').length})`);

  ZoomSlider();
};

$(document).on('skuSelected.vtex', async function (_, __, sku) {
  Notifyme(sku);

  if (!isPageKitBiquini) {
    await applyImagesOnSkuChange(sku.sku);
  }
});

$(document).on('skuSelectable.vtex', async function (_, __, skus) {

  if (!isPageKitBiquini) {
    const sku = skus[0];
    await applyImagesOnSkuChange(sku.sku);
  }
});

if (isPageKitBiquini) {
  const $cloned = $('.topic.Cor:eq(0)').closest('.sku-selector-container').clone(true, true);
  $cloned.find('.topic.Tamanho').remove();
  $('.product-selection').eq(0).append($cloned);

  updateFocusImageOnKits();

  $('.deselect-variant').on('click', function (event) {
    const $parent = $(event.currentTarget).closest('.box-kit').find('.sku-selector-container');
    const $unavaliable = $parent.find('.item_unavaliable');
    $parent.data().skuSelector.resetDimension({ name: 'Tamanho' });
    $unavaliable.addClass('item_unavaliable');
    $(event.currentTarget).closest('.box-kit').removeClass('sku-selected');
  });

  $(document).on('skuSelected.vtex', function (e) {
    $(e.target).closest('.box-kit').addClass('sku-selected');
  });

  $('body').addClass('js-enable');

  $('.box-kit').each((_, e) => {
    const $kit = $(e);

    discountFlag(
      Number(
        $kit
          .find('.skuListPrice')
          ?.html()
          ?.trim()
          ?.replace(/[^0-9,]/g, '')
          ?.replace(',', '.'),
      ),
      Number(
        $kit
          .find('.skuBestPrice')
          ?.html()
          ?.trim()
          ?.replace(/[^0-9,]/g, '')
          ?.replace(',', '.'),
      ),
      $kit.find('.product-kit-image'),
    );
  });

  $('body').addClass('js-enable');
}

function FixSkuSelector() {
  try {
    // @ts-ignore
    window.showSkuName = function () {};
    fetch(`/api/catalog_system/pub/products/search?fq=productId:${window.skuJson.productId}`)
      .then((response) => response.json())
      .then((data) => {
        const dataValue = data[0].items;

        for (let i = 0; i < dataValue.length; i++) {
          const skuData = {} as any;
          const itemObj = dataValue[i] || {};
          const defaultSeller = itemObj.sellers.find((seller) => seller.sellerDefault === true) || {};
          const offer = defaultSeller.commertialOffer || {};
          const bestInstallment = offer.Installments.reduce(
            (a, b) => {
              if (a.Value === null) return b;
              return a.Value < b.Value ? a : b;
            },
            { Value: null },
          );
          const baseImage = 'https://lojaaguadecoco.vteximg.com.br/';
          const arquivos = 'arquivos/ids/';
          const endImage = '.jpg?v=638597532903900000';

          skuData.id = itemObj.itemId;
          skuData.idProduct = window.skuJson.productId;
          skuData.name = itemObj.name;
          skuData.listPrice = offer.ListPrice;
          skuData.price = offer.Price;
          skuData.availability = offer.IsAvailable;
          skuData.availabilitymessage = '';
          skuData.bestInstallmentValue = bestInstallment.Value;
          skuData.bestInstallmentNumber = bestInstallment.NumberOfInstallments;
          skuData.images = itemObj.images.reduce((acc, image, index) => {
            acc.push([
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-728-1090/${image.imageText}.jpg?v=638597532903900000`,
                IsMain: index === 0,
                ArchiveTypeId: 2,
              },
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-728-1090/${image.imageText}${endImage}`,
                IsMain: index === 0,
                ArchiveTypeId: 3,
              },
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-65-65/${image.imageText}${endImage}`,
                IsMain: index === 0,
                ArchiveTypeId: 1,
              },
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-1920-2876/${image.imageText}${endImage}`,
                IsMain: index === 0,
                ArchiveTypeId: 10,
              },
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-90-90/${image.imageText}${endImage}`,
                IsMain: index === 0,
                ArchiveTypeId: 29,
              },
              {
                IdArchive: image.imageId,
                Name: image.imageLabel,
                Path: `${baseImage}${arquivos}${image.imageId}-571-845/${image.imageText}${endImage}`,
                IsMain: index === 0,
                ArchiveTypeId: 30,
              },
            ]);
            return acc;
          }, []);
          skuData.reference = itemObj.referenceId.find((ref) => ref.Key === 'RefId').Value;
          skuData.hasExtendedWarranty = false;
          skuData.hasExtendedWarrantyPage = '';
          skuData.notifyMe = true;
          skuData.HasServiceAtServicePage = false;
          skuData.HasServiceAtCartPage = false;
          skuData.HasServiceAtProductPage = false;
          skuData.RealHeight = 0;
          skuData.RealWidth = 0;
          skuData.RealLength = 0;
          skuData.RealWeightKg = 0;
          skuData.RewardValue = 0;
          skuData.Ean = itemObj.ean;
          skuData.DefaultSellerId = defaultSeller.sellerId;
          skuData.SkuSellersInformation = [
            {
              IsDefaultSeller: true,
              SellerId: defaultSeller.sellerId,
              Name: defaultSeller.sellerName,
              LogoUrl: null,
              ListPrice: offer.ListPrice,
              Price: offer.Price,
              PriceWithoutDiscount: offer.PriceWithoutDiscount,
              AvailableQuantity: offer.AvailableQuantity,
            },
          ];
          // @ts-ignore
          ListSkuData['sku' + itemObj.itemId] = skuData;
        }
      });
  } catch (error) {
    console.error('Erro ao buscar dados do produto', error);
  }
}

function ShowsSzbChart() {
  const targetNode = document.body;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const chartButton = document.querySelector('#szb-measurements-button');
        if (chartButton) {
          document.body.classList.add('has-measurement');
        }
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });
}

const Notifyme = (_sku) => {
  const { skus } = window.skuJson;
  const formContainer = document.querySelector('.product-add-to-cart');

  const showUnavailableForm = () => {
    formContainer?.classList.add('show-unavailable-form');
  };

  const hideUnavailableForm = () => {
    formContainer?.classList.remove('show-unavailable-form');
  };

  const markSizeAsUnavailable = (size, skuId) => {
    const btn = document.querySelector(`.skuList.item-dimension-Tamanho input[value="${size}"]`);
    btn?.classList.add('item_unavaliable');
    $('[name="notifymeIdSku"]').val(String(skuId));
    $('.sku-notifyme-button-ok').val('AVISE-ME').addClass('ready btn');
  };

   skus.forEach((sku) => {
    if (!sku.available) {
      showUnavailableForm();
      markSizeAsUnavailable(sku.dimensions.Tamanho, sku.sku);
    }

    hideUnavailableForm();
   });
  
  if (!_sku.available) {
    showUnavailableForm();
    markSizeAsUnavailable(_sku.dimensions.Tamanho, _sku.sku);
  }

 
};

$(document).ready(function () {
  //@ts-ignore
Notifyme({ available: window.skuJson_0 });

  try {
    // window.imageControl_OnSkuImageRelatedSpecSelected = function () {
    //   console.log('🚀 ~ imageControl_OnSkuImageRelatedSpecSelected');
    // };
    // for (const key in skuEventDispatcher.events.skuDataReceived.listeners) {
    //   if (Object.prototype.hasOwnProperty.call(skuEventDispatcher.events.skuDataReceived.listeners, key)) {
    //     const listener = skuEventDispatcher.events.skuDataReceived.listeners[key];
    //     console.log('🚀 ~ listener.name:', listener.name);
    //     if (listener.name === 'imageControlListener' || listener.name === 'imageControlSpecSelectedListener') {
    //       skuEventDispatcher.events.skuDataReceived.listeners[key].callback = function () {
    //         console.log('bo');
    //       };
    //     }
    //   }
    // }
  } catch (error) {
    console.error(error);
  }
});

ShowsSzbChart();

FixSkuSelector();
